// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProducaoKpi_CardsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/producao_kpi/cards.
 *
 * All duration values (prazo_medio_entrega) are int * 100 for two decimal
 * places. Production rates (media_entrada_itens, etc.) are also int * 100.
 * Itens_atrasados is an absolute count.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ProducaoKpi_CardsResponseDados {
prazo_medio_entrega: number
media_entrada_itens: number
media_producao_diaria: number
meta_producao_diaria: number
itens_atrasados: number
}

export type ProducaoKpi_CardsResponse = ApiResponse<ProducaoKpi_CardsResponseDados>;

registerResponseContract('ProducaoKpi_CardsResponse', {
  prazo_medio_entrega:   { type: 'number',  required: true },
  media_entrada_itens:   { type: 'number',  required: true },
  media_producao_diaria: { type: 'number',  required: true },
  meta_producao_diaria:  { type: 'number',  required: true },
  itens_atrasados:       { type: 'number',  required: true },
})
